module.exports = __webpack_public_path__ + "img/presupuesto.7489b233.jpeg";